module.exports = __webpack_public_path__ + "static/media/imageStep3.9e4491d3.svg";